module.exports = __webpack_public_path__ + "img/tools-data-quality.73a24bdb.png";